<template>
  <div>
    <div class="mobile-wrapper">
      <div class="mobile-headder" :style="isShow == true ? HeadeStyles : ''">
        <router-link to="/" tag="div" class="h-left">
          <span class="iconfont logo" style="font-size:30px;color:#fff;"
            >&#xe6d9;</span
          >
        </router-link>
        <!-- <div class="nav-text">
          <p>{{ $route.meta.title }}</p>
        </div> -->
        <div class="nav-img" @click="showPopup">
          <el-image src="/static/images/line.png" fit="cover"></el-image>
        </div>
      </div>
      <van-popup
        v-model="vanshow"
        position="left"
        :close-on-popstate="true"
        :style="{ height: '100%', width: '50%' }"
      >
        <div class="mobile-logo_hover">
          <router-link to="/" tag="div">
            <span class="iconfont logo" style="font-size:48px;color:#E60012;"
              >&#xe6d9;</span
            >
          </router-link>
        </div>
        <router-link
          v-for="(item, index) in headtab"
          :key="index"
          :to="item.link"
          @click.native="hidePopup"
          tag="div"
          class="mobile-headder-item mobile-dynamic-border"
        >
          <span class="title">{{ item.text }}</span>
          <van-icon name="arrow" />
        </router-link>
        <!-- <el-select
          v-model="langeVal"
          placeholder="语言选择"
          @change="changeLang"
          class="mobile-headder-item mobile-dynamic-border mobile-headder-no-padding"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            color="#000"
          >
          </el-option>
        </el-select> -->
      </van-popup>
    </div>
    <div class="pc-wrapper">
      <div class="pc-headder" :style="isShow == true ? HeadeStyles : ''">
        <div>
          <router-link to="/" tag="div" class="headder-item">
            <span class="iconfont logo">&#xe6d9;</span>
          </router-link>
        </div>
        <div class="headderDiv">
          <router-link
            v-for="(item, index) in headtab"
            :key="index"
            :to="item.link"
            tag="div"
            class="headder-item dynamic-border"
          >
            <span class="title">{{ item.text }}</span>
          </router-link>
          <div class="headder-item dynamic-border" @click="loadData">
            App 下载
          </div>
          <!-- <div class="headder-item dynamic-border" @click="changeLang">
          客服热线: 4009-020-668
        </div> -->
          <!-- <el-select
            v-model="langeVal"
            placeholder="语言选择"
            class="headder-item dynamic-border"
            @change="changeLang"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <!-- <div
            id="translate"
            class="el-select headder-item dynamic-border"
          ></div> -->
        </div>
      </div>
    </div>
    <service-dialog :show.sync="show"></service-dialog>
  </div>
</template>

<script>
import serviceDialog from "./appdialog";
import { GET_DOWNLOAD } from "@/api/mall";
export default {
  name: "app-header",
  components: {
    serviceDialog
  },
  computed: {
    headtab() {
      return [
        {
          index: 1,
          text: "首页",
          link: "/top"
        },
        {
          index: 2,
          text: "关于我们",
          link: "/about"
        },
        {
          index: 3,
          text: "联系我们",
          link: "/contactus"
        },
        {
          index: 4,
          text: "MOD下载",
          link: "/moddownload"
        }
      ];
    }
  },
  data() {
    return {
      vanshow: false,
      show: false,
      options: [
        {
          value: "zh",
          label: "中文简体"
        },
        {
          value: "en",
          label: "English"
        },
        {
          value: "ko",
          label: "한국인"
        },
        {
          value: "ru",
          label: "Русский"
        }
      ],
      langeVal: "zh",
      activeIndex: 1,

      HeadeStyles: {
        background: "rgba(0, 0, 0, 0.6)"
      },
      isShow: false
    };
  },
  methods: {
    showPopup() {
      this.vanshow = true;
    },
    hidePopup() {
      this.vanshow = false;
    },
    loadData() {
      this.show = true;
    },
    changeLang(e) {
      localStorage.language = e;
      let locale = localStorage.getItem("language") || e;
      // var lib = new google.translate.TranslateService();
      // lib.translatePage("zh-cn", locale, function() {});
      console.log("locale", locale);
      this.$translate.setUseVersion2();
      this.$translate.language.setLocal(locale);
      this.$translate.execute();
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 240) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  },
  mounted() {
    // let val = document.getElementById("translateSelectLanguage");
    // console.log("val", val);
    // this.langeVal = localStorage.getItem("language")
    //   ? localStorage.getItem("language")
    //   : "zh";
    // this.$translate.setUseVersion2();
    // this.$translate.language.setLocal(this.langeVal);
    // this.$translate.execute();
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss" scoped type="text/scss">
.pc-wrapper {
  display: block;
}

.mobile-headder {
  display: none;
}
.pc-headder {
  width: 90%;
  display: flex;
  justify-content: space-between;
  padding: 30px 5%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  z-index: 10;
  .logo {
    font-size: 50px;
  }
  img {
    width: 60px;
  }
  .headderDiv {
    width: 50%;
    display: flex;
    justify-content: space-around;
  }
  .headder-item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    color: white;
  }
}

.pc-headder .headder-item:nth-last-of-type(1) {
  color: #fff;
}
.pc-headder .router-link-exact-active {
  color: #e9bb00;
}
/* 移动端  */
@media all and (max-width: 768px) {
  .pc-wrapper {
    display: none;
  }
  .mobile-headder {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 30;
    width: 100%;
    // height: 80px;
  }
  .mobile-headder {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    .nav-text {
      // flex: 1;
      p {
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }
    }
    .h-left {
      width: 20%;
      margin-left: 10px;
    }
    .nav-img {
      width: 20%;
      ::v-deep img {
        width: 50%;
      }
    }
  }
  .mobile-logo_hover {
    margin: 20px 0;
  }
  .mobile-headder-no-padding {
    padding: 5px 0 !important;
  }
  .mobile-headder-item {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #000;
    padding: 20px 0;
    margin: 0 20px;
    font-size: 16px;
    color: black;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue